import { render, staticRenderFns } from "./PartnerProfiles.vue?vue&type=template&id=db3d470e&scoped=true"
import script from "./PartnerProfiles.vue?vue&type=script&lang=js"
export * from "./PartnerProfiles.vue?vue&type=script&lang=js"
import style0 from "./PartnerProfiles.vue?vue&type=style&index=0&id=db3d470e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db3d470e",
  null
  
)

export default component.exports